var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.searchTerm && !_vm.isFetching
        ? _c("div", { staticClass: "mb-3 text-uppercase" }, [
            _vm._v(
              "\n    " +
                _vm._s(
                  'Search results for"' +
                    _vm.searchTerm +
                    '" (' +
                    _vm.finalImages.length +
                    ")"
                ) +
                "\n  "
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { class: [_vm.isPdp ? "w-100" : ""] },
        [
          !_vm.isFetching && _vm.finalImages.length === 0
            ? _c(
                "div",
                { staticClass: "no-results justify-content-center" },
                [
                  _c("Icon", {
                    staticClass: "w-100",
                    attrs: {
                      icon: "fluent:search-info-24-regular",
                      color: "#959595",
                      width: "30px"
                    }
                  }),
                  _vm._v(" "),
                  _c("p", { staticClass: "no-results-header text-center" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.$resourceString[
                            "inspiration.images.gallery.no.images.header"
                          ]
                        ) +
                        "\n      "
                    )
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "no-results-subheader text-center" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.$resourceString[
                            "inspiration.images.gallery.no.images.subheader"
                          ]
                        ) +
                        "\n      "
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "no-results-box" }, [
                    _c("div", { staticClass: "button-label" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.$resourceString[
                              "inspiration.images.gallery.no.images.need.assistance"
                            ]
                          ) +
                          "\n        "
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "btn btn-primary text-uppercase",
                        attrs: { href: "/Contact-Us" }
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.$resourceString[
                                "inspiration.images.gallery.no.images.contact.us"
                              ]
                            ) +
                            "\n        "
                        )
                      ]
                    )
                  ])
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.finalImages.length > 0 && !_vm.isWidget
            ? _c("div", [
                _vm.isPdp
                  ? _c(
                      "h4",
                      {
                        staticClass:
                          "primary-heading text-lowercase font-weight-bold mb-3 patcraft-text-underline",
                        attrs: {
                          "data-text": _vm.productInstallLabel
                            ? _vm.productInstallLabel.slice(0, 3)
                            : ""
                        }
                      },
                      [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.productInstallLabel) +
                            "\n      "
                        )
                      ]
                    )
                  : _c("h4", { staticClass: "secondary-heading" }, [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.productInstallLabel) +
                          "\n      "
                      )
                    ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "gallery-block-mobile" }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "wf-inspiration-items-desktop d-flex flex-wrap" },
            [
              _vm._l(_vm.numberOfImages, function(index) {
                return _vm.numberOfImages && _vm.numberOfImages > 0
                  ? _c(
                      "div",
                      {
                        key: index,
                        staticClass:
                          "wf-inspiration-item inspiration-page-gallery-item"
                      },
                      [
                        _vm.finalImages[index - 1]
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "\n        wf-inspiration-overlay-button-open\n        inspiration-page-gallery-item-button\n        position-relative\n      "
                              },
                              [
                                _c("span", {
                                  staticClass:
                                    "png-icon png-icon-icons-glyph--ko-heart cursor-pointer position-absolute mt-3 insp-gallery-heart",
                                  on: {
                                    click: function($event) {
                                      return _vm.showContentWizard(
                                        _vm.finalImages[index - 1]
                                      )
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "w-100 h-100 bg-light" },
                                  [
                                    _c("img", {
                                      class: "image wf-inspiration-grid-image",
                                      attrs: {
                                        "wrapper-class": "w-100 h-100 bg-light",
                                        src: _vm.$helpers.getWidenImgURL(
                                          _vm.finalImages[index - 1].embedId,
                                          1000
                                        ),
                                        alt:
                                          _vm.finalImages[index - 1]
                                            .imageAltText || ""
                                      }
                                    })
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "\n          wf-inspiration-overlay-button-open-text\n          secondary-heading cursor-pointer\n          info-secondary-heading\n          inspiration-page-gallery-item-name\n        ",
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        $event.stopPropagation()
                                        return _vm.onImgClick(
                                          _vm.finalImages[index - 1]
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(
                                          _vm.finalImages[index - 1]
                                            .displayCollectionName
                                        ) +
                                        "\n          "
                                    )
                                  ]
                                )
                              ]
                            )
                          : _vm._e()
                      ]
                    )
                  : _vm._e()
              }),
              _vm._v(" "),
              _vm._l(_vm.finalImages, function(image) {
                return !_vm.numberOfImages && _vm.numberOfImages != 0
                  ? _c(
                      "div",
                      {
                        key: image.embedId,
                        staticClass:
                          "wf-inspiration-item inspiration-page-gallery-item"
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "\n            wf-inspiration-overlay-button-open\n            inspiration-page-gallery-item-button\n            position-relative\n          "
                          },
                          [
                            _c("span", {
                              staticClass:
                                "png-icon png-icon-icons-glyph--ko-heart cursor-pointer position-absolute mt-3 insp-gallery-heart",
                              on: {
                                click: function($event) {
                                  return _vm.showContentWizard(image)
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "w-100 h-100 bg-light" }, [
                              _c("img", {
                                class: "image wf-inspiration-grid-image",
                                attrs: {
                                  "wrapper-class": "w-100 h-100 bg-light",
                                  src: _vm.$helpers.getWidenImgURL(
                                    image.embedId,
                                    1000
                                  ),
                                  alt: image.imageAltText || ""
                                }
                              })
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "\n              wf-inspiration-overlay-button-open-text\n              secondary-heading cursor-pointer\n              info-secondary-heading\n              inspiration-page-gallery-item-name\n            ",
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    $event.stopPropagation()
                                    return _vm.onImgClick(image)
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(image.displayCollectionName) +
                                    "\n          "
                                )
                              ]
                            )
                          ]
                        )
                      ]
                    )
                  : _vm._e()
              }),
              _vm._v(" "),
              _vm.showLoadMore && !_vm.isPdp
                ? _c("pc-load-more", { attrs: { "load-more": _vm.onLoadMore } })
                : _vm._e()
            ],
            2
          ),
          _vm._v(" "),
          _vm.isPdp
            ? _c(
                "div",
                {
                  staticClass:
                    " inspiration-btn wf-cta-block-call-to-action-buttons text-center"
                },
                [
                  _c(
                    "a",
                    {
                      staticClass:
                        "call-to-action-button btn btn-white border-accent-gray-alt bg-transparent",
                      attrs: { target: "_self" },
                      on: {
                        click: function($event) {
                          return _vm.inspirationRedirect()
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm.$resourceString[
                              "product.details.side.inspiration.label"
                            ]
                          ) +
                          "\n        "
                      ),
                      _c("span", {
                        staticClass:
                          "png-icon png-icon-icons-glyph--k-arrow-next"
                      })
                    ]
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.imgPreviewOpened ? _c("pc-inspiration-images-gallery") : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "modal",
        {
          staticClass: "my-project-modal",
          attrs: {
            height: "650",
            name: "project-wizard-image-content-modal",
            "data-html2canvas-ignore": "true",
            adaptive: true,
            scrollable: true
          }
        },
        [
          _c("pc-project-wizard-content-modal", {
            on: {
              closeModal: function($event) {
                return _vm.closeModal($event)
              }
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }